export default __webpack_public_path__ + "static/348-332e725ea6cc685fc7aae0517c5409b0.gif";